module.exports = __webpack_public_path__ + "img/precision_manufacturing_outlined.b7071587.svg";